import React from 'react'
import { withLazyRoute } from '@/components/Lazy/LazyRouteWrapper'

export const AccountSettings = withLazyRoute(
  React.lazy(() => import('./AccountSettings')),
  'Loading account settings...',
)

export const NeedsResetPassword = withLazyRoute(
  React.lazy(() => import('./NeedsResetPassword')),
  'Loading needs reset password...',
)

export const NotificationCenter = withLazyRoute(
  React.lazy(() => import('./NotificationCenter')),
  'Loading notification center...',
)

export const SupportRequest = withLazyRoute(
  React.lazy(() => import('./SupportRequest')),
  'Loading support request...',
)

export const UserListBuilder = withLazyRoute(
  React.lazy(() => import('./UserListBuilder')),
  'Loading user list builder...',
)
